var cilViewModule = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,64V448H496V64ZM464,240H352V96H464Zm-272,0V96H320V240Zm128,32V416H192V272ZM160,96V240H48V96ZM48,272H160V416H48ZM352,416V272H464V416Z' class='ci-primary'/>"];

export { cilViewModule };

